module.exports = __webpack_public_path__ + "img/farzana-christopher-110.2817fa23.jpg";